import { Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { ToasterService } from 'src/app/core/services/toastr.service';
import { TeamsService } from 'src/app/core/services/teams.service';
import { GeoFenceService } from 'src/app/core/services/geo-fence.service';
import { geofenceData, geofenceListing } from 'src/app/models/geofenceData';
import { driverData } from 'src/app/models/driverData';
import { CommonResponse } from 'src/app/models/commomResponse';
import { teamListwithGeofenceResponse } from 'src/app/models/teamListwithGeofence';

@Component({
  selector: 'megastore-admin-add-team',
  templateUrl: './add-team.component.html',
  styleUrls: ['./add-team.component.scss']
})
export class AddTeamComponent implements OnDestroy {
  teamFormGroup: FormGroup;
  submitted = false;
  destroy$: Subject<boolean> = new Subject<boolean>();
  teamId: string | undefined;
  geofenceList: Array<geofenceData> = [];
  driverList: Array<driverData> = [];
  geofenceSelected = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { data: string },
    private dialog: MatDialogRef<AddTeamComponent>,
    private formBuilder: FormBuilder,
    private _toasterService: ToasterService,
    private _teamsSerive: TeamsService,
    private _geoFenceService: GeoFenceService,
    private _spinnerService: SpinnerService,
    private _translateService: TranslateService
  ) {
    this.teamFormGroup = this.formBuilder.group({
      teamName: [
        '',
        [Validators.required, Validators.maxLength(40), Validators.minLength(3)]
      ],
      geofenceId: ['', [Validators.required]],
      // drivers: [[], [Validators.required]]
    });

    this.getGeofenceData();
    if (this.data.data !== undefined) {
      this.teamFormGroup.get('geofenceId')?.disable();
      this.getTeamData();
      this.teamId = this.data.data;
    }
  }

  getTeamData(): void {
    this._spinnerService.addToLoader('getTeamData');
    this._teamsSerive
      .getTeamsById(this.data.data)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: teamListwithGeofenceResponse) => {
          this._spinnerService.removeFromLoader('getTeamData');
          this.teamFormGroup.patchValue(res);
          this.afterGeofence(res.geofenceId);
        },
        error: () => {
          this._spinnerService.removeFromLoader('getTeamData');
        }
      });
  }

  getGeofenceData(): void {
    this._spinnerService.addToLoader('getGeofenceData');
    this._geoFenceService
      .getGeofenceListing('')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: geofenceListing) => {
          this._spinnerService.removeFromLoader('getGeofenceData');
          this.geofenceList = res.doc;
        },
        error: () => {
          this._spinnerService.removeFromLoader('getGeofenceData');
        }
      });
  }

  afterGeofence(id: string | undefined): void {
    this.getDriverData(id);
  }

  getDriverData(id: string | undefined): void {
    let query = '';
    if (this.data.data) {
      query = `type=edit&teamId=${this.teamId}`;
    }
    this._spinnerService.addToLoader('getDriver');
    this._geoFenceService
      .getDriverByGeofence(id, query)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: Array<driverData>) => {
          this._spinnerService.removeFromLoader('getDriver');
          this.geofenceSelected = true;
          this.driverList = res;
          if (this.driverList && this.driverList.length) {
            this.teamFormGroup
              .get('drivers')
              ?.addValidators(Validators.required);
            this.teamFormGroup.get('drivers')?.updateValueAndValidity();
            const selectedDrivers = this.driverList.filter(
              item => item.isDriverInTeam
            );
            this.teamFormGroup.patchValue({
              drivers: selectedDrivers.map(driver => driver._id)
            });
          } else {
            this.teamFormGroup.get('drivers')?.clearValidators();
            this.teamFormGroup.get('drivers')?.updateValueAndValidity();
          }
        },
        error: () => {
          this._spinnerService.removeFromLoader('getDriver');
        }
      });
  }

  getPlaceholder(): string {
    if (!this.geofenceSelected && this.driverList && !this.driverList.length) {
      return 'Drivers';
    } else if (this.geofenceSelected && this.driverList && this.driverList.length) {
      return 'Drivers';
    } else {
      return 'nodriverAvailable';
    }
  }

  onSubmit(): void {
    this.submitted = true;
    this.teamFormGroup.get('geofenceId')?.enable();
    this.teamFormGroup.patchValue({
      teamName: this.teamFormGroup.get('teamName')?.value.trim()
    });
    if (this.teamFormGroup.valid) {
      this.onFormValid();
    }
  }

  onFormValid(): void {
    this._spinnerService.addToLoader('addTeam');
    (this.data.data ? this._teamsSerive.updateTeam(this.teamFormGroup.value, this.teamId) : this._teamsSerive.addTeam(this.teamFormGroup.value)
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: CommonResponse) => {
          if (res) {
            this._spinnerService.removeFromLoader('addTeam');
            this._toasterService.successToastr(
              this._translateService.instant('Successful')
            );
            this.dialog.close(res);
          }
        },
        error: () => {
          this._spinnerService.removeFromLoader('addTeam');
        }
      });
  }
  ngOnDestroy(): void {
    this.destroy$.complete();
    this.destroy$.unsubscribe();
  }
}
